import {observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {LinkSuggestionsDropdownController} from '../DropdownController/LinkSuggestionsDropdownController';
import {InternalLinksSuggestions} from './InternalLinkSuggestions/InternalLinkSuggestions';
import {CommonCitations} from './CommonCitations/CommonCitations';
import {useStore} from '@/store/root-store';
import {SuggestionsDataController} from '../DropdownController/SuggestionsDataController';
import {toJS} from 'mobx';
import {Button, Input, Popover, Radio, Spin, Tooltip, Form} from 'antd';
import {exportLinkIcon} from '@/utils/icons';
import {LoadingOutlined} from '@ant-design/icons';
import {faCircleInfo} from '@fortawesome/pro-duotone-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
// import { SmallBadge } from '@/components/common-components/components/badge';
import {Pill} from '@/components/layoutV2/user-menu/styles';
import isURL from 'validator/lib/isURL';
import {getLocalesByKey as t} from '@/utils/translation';
import {CustomTextarea} from '@/components/common-components/components/form/input/customTextarea';
import {stringToArray} from '@/utils/arrays';
import {keywordNewLineReg} from '@/constants/regex';
import {notification} from '@/utils/notification';
import {apiError} from '@/utils/api';

interface LinkSuggestionTabPRops {
  viewSuggestionsOption: boolean;
  linksDropDownFromSuggestion: 'links' | 'terms';
}

export const LinkSuggestionsTab = observer(({viewSuggestionsOption, linksDropDownFromSuggestion}: LinkSuggestionTabPRops) => {
  const [currentView, setCurrentView] = useState<'links' | 'terms'>('links');
  const [activeKeywordsList, setActiveKeywordsList] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [initialDataArr, setInitialDataArr] = useState([]);
  const [isQueried, setIsQueried] = useState<boolean>(false);
  const [anyButtonClicked, setAnyButtonClicked] = useState(false);
  const antIcon = <LoadingOutlined style={{fontSize: '15px', marginRight: 5, color: 'white'}} spin />;
  const {settings: {customer: {getCustomerQuota}}} = useStore('');
  const [selectedOption, setSelectedOption] = useState('domain');
  const [domain, setDomain] = useState('');
  const [isVisiblePopover, setIsVisiblePopover] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [urlsError, setUrlsError] = useState('');
  const [form] = Form.useForm();

  const [inputValue, setInputValue] = useState('');

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  useEffect(() => {
    if (linksDropDownFromSuggestion) {
      setCurrentView(linksDropDownFromSuggestion);
    }
  }, [linksDropDownFromSuggestion]);

  useEffect(() => {
    // we are using loading boolean which goes true before api is fired and false afterwards
    // to avoid multiple rerendering we are only checking for false value
    if (currentPage?.isFetchingIntLinksSug) return;

    const activeKwArr = [];

    if (toJS(currentPage)?.content?.internalLinkSuggestionsV2?.keywords?.length) {
      for (let i = 0; i < toJS(currentPage).content.internalLinkSuggestionsV2.keywords.length; i++) {
        activeKwArr.push({
          keyword: toJS(currentPage).content.internalLinkSuggestionsV2.keywords[i],
          active: true,
        });
      }
    }


    setActiveKeywordsList(activeKwArr);

    setDataArr(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks ?? []);
    setInitialDataArr(toJS(currentPage).content?.internalLinkSuggestionsV2?.allLinks ?? []);
  }, [currentPage?.isFetchingIntLinksSug]);

  const onDataFilter = (keywordsArray: any[]) => {
    setActiveKeywordsList(keywordsArray);
    filterDataHandler();
  };

  const setLinks = (query?: string[]) => {
    setSearchQuery(query);
    filterDataHandler();
  };


  const customLinkActionCallback = () => {
    setDataArr(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks ?? []);
    setInitialDataArr(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks || []);
    filterDataHandler(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks);
  };

  const filterDataHandler = (customDataArr?: any[]) => {
    const formattedArr = activeKeywordsList.filter(item => item.active === true);
    const prepDataArr = [];
    const dataArr = customDataArr ?? initialDataArr;

    for (let i = 0; i < formattedArr.length; i++) {
      const foundLinks = dataArr.filter(link => link.keywords.includes(formattedArr[i].keyword));
      for (let n = 0; n < foundLinks.length; n++) {
        if (!prepDataArr.filter(item => item.url === foundLinks[n].url)?.length) {
          prepDataArr.push(foundLinks[n]);
        }
      }
    }

    let filteredSelectedLinks = [];
    if (searchQuery?.length > 1 || (searchQuery?.length === 1 && searchQuery[0] !== '')) {
      setIsQueried(true);
      for (let i = 0; i < prepDataArr.length; i++) {
        for (let n = 0; n < searchQuery.length; n++) {
          const foundLink = prepDataArr[i].title?.toLowerCase().includes(searchQuery[n]?.toLowerCase());
          if (foundLink) {
            filteredSelectedLinks.push(prepDataArr[i]);
          }
        }
      }
    } else {
      setIsQueried(false);
      for (let i = 0; i < prepDataArr.length; i++) {
        filteredSelectedLinks = [...filteredSelectedLinks, prepDataArr[i]];
      }
    }
    setDataArr(filteredSelectedLinks);
  };
  const calculateUsagePercentage = (data: any[]): number => {
    if (data?.length) {
      return (data.filter(link => link.isUsed).length * 100) / data.length;
    } else {
      return 0;
    }
  };


  const getMsg = (perc: number): string => {
    let msg = '';
    if (perc === null) return '';

    if (perc < 100) {
      msg = `Add more links to improve this site's linking profile.`;
    } else {
      msg = 'Amazing! All links included.';
    }

    return msg;
  };
  const postLInkSuggestion = async type => {
    const links = type == 'links' ? dataArr?.sort((a, b) => a.isBookmarked > b.isBookmarked ? -1 : 1).map(({url})=> url) : currentPage?.analytics?.commonCitations.map(item => toJS(item).url);
    currentPage?.setLinksForInsertion([...links]);
    try {
      setAnyButtonClicked(true);
      await currentPage.fetchLinkSuggestions([...links]);
      currentPage.setIsLinkActive(true);
      getCustomerQuota();
    } catch (e) {
      return Promise.reject(e);
    } finally {
      setAnyButtonClicked(false);
    }
  };

  const initValues = () => {
    setInputValue('');
    setDomain('');
    form.resetFields(['urlInput']);
    setSelectedOption('domain');
  };

  const handleRadioChange = e => {
    setSelectedOption(e.target.value);
    setDomain('');
    setInputValue('');
    form.resetFields(['urlInput']);
    setUrlsError('');
  };

  const submitUrl = async () => {
    setUpdateLoading(true);
    try {
      if (selectedOption === 'domain') {
        await currentPage?.updateHostname(domain);
        await currentPage?.getInternalLinkSuggestionsv2(currentPage?.content?.uuid, true);
        notification.success('', 'Domain updated successfully');
        setIsVisiblePopover(false);
        initValues();
      } else {
        if (inputValue.length) {
          const links = stringToArray(inputValue, keywordNewLineReg, ',');
          const urlWithProtocols = links.map(value => value.startsWith('/') ? value.slice(1) : value);
          await currentPage.fetchLinkSuggestions(urlWithProtocols);
          currentPage.setIsLinkActive(true);
          notification.success('', 'URLs updated successfully');
          getCustomerQuota();
          setIsVisiblePopover(false);
          initValues();
          setUrlsError('');
        } else {
          setUrlsError('URL is required.');
        }
      }
    } catch (error) {
      const errorMessage = apiError(error) as string;
      notification.error('', errorMessage, false, 'OK');
      Promise.reject(error);
    } finally {
      setUpdateLoading(false);
    }
  };

  const onVisibleChange = value => {
    setIsVisiblePopover(value);
    initValues();
    setUrlsError('');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e?.nativeEvent['data'] == ',') {
      setInputValue(e?.target?.value?.replace(',', '\n'));
    } else {
      if (e.target.value.length) setUrlsError('');
      setInputValue(e?.target?.value);
    }
  };

  const addDomainPopoverContent = () => {
    return <PopoverContentWrapper>
      <PopoverTitle>To continue, provide a source of Internal links</PopoverTitle>
      <Form
        form={form}
        initialValues={{
          urlInput: domain,
          providedUrl: inputValue,
        }}
      >
        <AddDomainSection>
          <div>
            <Radio.Group onChange={handleRadioChange} value={selectedOption}>
              <Radio value='domain' />
            </Radio.Group>
          </div>
          <DomainDetails>
            <AddDomainTitle>Add a domain</AddDomainTitle>
            <AddDomainDesc>We’ll scan the domain and provide inlinks recommendations </AddDomainDesc>
            {selectedOption === 'domain' &&
            <Form.Item
              name='urlInput'
              rules={[
                {
                  required: true,
                  message: t('url-is-required'),
                },
                () => ({
                  validator(_, value) {
                    if (!value || isURL(value.trim(), {require_protocol: false})) {
                      return Promise.resolve();
                    }
                    return Promise.reject(t('url-not-valid'));
                  },
                }),
              ]}
            >
              <AddDomainInput
                placeholder='domain.com'
                onChange={e => setDomain(e.target.value)}
              />
            </Form.Item>
            }
          </DomainDetails>
        </AddDomainSection>
        <ProvideUrlsSection>
          <div>
            <Radio.Group onChange={handleRadioChange} value={selectedOption}>
              <Radio value='urls' />
            </Radio.Group>
          </div>
          <ProvideUrlsDetails>
            <AddDomainTitle>Provide URLs</AddDomainTitle>
            <AddDomainDesc>Write or paste a list of URLs and we’ll find the best fit for them</AddDomainDesc>
            {selectedOption === 'urls' &&
            <>
              <CustomTextarea
                paddingToNumber='15px'
                paddingToText='12px'
                isKeyWordv2={true}
                autoSize={true}
                minHeight='185px'
                maxHeight='185px'
                width='400px'
                variant='customLinks'
                autoSizeCheck={true}
                placeholder='Enter urls separated by commas'
                onChange={handleInputChange}
                value={inputValue}
              ></CustomTextarea>
              {urlsError&& <ErrorMessageForURL>{urlsError}</ErrorMessageForURL>}
            </>
            }
          </ProvideUrlsDetails>
        </ProvideUrlsSection>
        <Footer>
          <Dismiss
            onClick={() => setIsVisiblePopover(false)}
          >
          Dismiss
          </Dismiss>
          <Update onClick={submitUrl}
            disabled={updateLoading || (selectedOption === 'domain' ? !domain : !inputValue)}
          >
            {updateLoading ? <Spin indicator={antIcon} /> : 'Update & Continue'}
          </Update>
        </Footer>
      </Form>
    </PopoverContentWrapper>;
  };

  const popoverInnerStyle = {
    width: '500px',
    borderRadius: '10px',
    border: '1px solid #D9D9D9',
    background: 'var(--White, #FFF)',
    boxShadow: '0px 1px 20px 0px rgba(0, 0, 0, 0.19)',
  };


  return <>
    <SuggestionsDataController
      store={currentPage}
      currentView={currentView}
      linksDropDownFromSuggestion={linksDropDownFromSuggestion}
      onViewChange={setCurrentView}
      updateKeywords={kwArr => {
        onDataFilter(kwArr);
      }}
      visibleKeywords={activeKeywordsList}
      onFilter={setLinks}
      viewSuggestionsOption={viewSuggestionsOption}
    />
    <Wrapper>
      <LinkSuggestionsDropdownController
        store={currentPage}
        currentView={currentView}/>
      <SuggestionsBannerContainer percent={calculateUsagePercentage(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks)}>
        <Tooltip overlayInnerStyle={{width: 300, background: '#121212'}} title={<>
          <TooltipTitle>
            Internal links help search engines understand how your content interrelates.
          </TooltipTitle>
          <TooltipDescription>
            {`Links in <body> of the page: ${toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks?.filter(link => link.isUsed).length ?? 0}/${toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks?.length ?? 0}`}
          </TooltipDescription>
        </>}>
          <FontAwesomeIcon icon={faCircleInfo} className='infoBannerIcon'/>
        </Tooltip>

        {getMsg(calculateUsagePercentage(toJS(currentPage)?.content?.internalLinkSuggestionsV2?.allLinks))}
      </SuggestionsBannerContainer>
      <LinksWrapper anyButtonClicked={anyButtonClicked}>
        <p>Add links to content easily with AI</p>
        {dataArr?.length && (currentView == 'links' || currentView == 'terms') ? <p onClick={()=> {
          (dataArr?.length && (currentView == 'links' || currentView == 'terms')) && postLInkSuggestion(currentView);
        }}> {anyButtonClicked ? <Spin indicator={antIcon}/> : exportLinkIcon()} Insert Links <Pill style={{marginRight: '-48px'}}>Beta</Pill></p>:
          <StyledPopover
            content={addDomainPopoverContent()}
            trigger={'click'}
            overlayInnerStyle={popoverInnerStyle}
            placement='bottomLeft'
            open={isVisiblePopover}
            onOpenChange={onVisibleChange}
          >
            <Tooltip title={anyButtonClicked ? <div style={{fontSize: 12}}>
              <div style={{fontWeight: 600}}>Launching AI Links Assistant.</div>
              <div>Do not modify your article before this tool is fully loaded</div>
            </div> : ''}>
              <p onClick={()=> {
                setIsVisiblePopover(true);
              }}> {anyButtonClicked ? <Spin indicator={antIcon}/> : exportLinkIcon()} Insert Links <Pill style={{marginRight: '-48px'}}>Beta</Pill></p></Tooltip>
          </StyledPopover>
        }
      </LinksWrapper>
      {currentView === 'links' ? <InternalLinksSuggestions customCallback={customLinkActionCallback} isQueried={isQueried} data={dataArr?.sort((a, b) => a.isBookmarked > b.isBookmarked ? -1 : 1)} store={currentPage}/> : <CommonCitations store={currentPage}/>}
    </Wrapper>
  </>;
});

const Wrapper = styled.div`
  background-color: #2d2f34;
  border-radius: 5px;
  padding: 0 0 13px 0;
`;
const SuggestionsBannerContainer = styled.div<{percent?: number}>`
  background-color: ${p => p.percent < 75 ? '#F1AA3E1C' : '#1FAC471C'};
  border-radius: 5px;
  padding: 9px 10px;
  font-size: 12px;
  margin: 10px 6px;

  .infoBannerIcon {
    width: 15px;
    color: ${p => p.percent < 75 ? '#F1AA3E' : '#1FAC47'};
    margin-right: 5px;
  }
`;

const TooltipTitle = styled.div`
`;
const TooltipDescription = styled.div`
  font-size: 12px;
  color: #a3a4a4;
`;

const LinksWrapper = styled.div<{anyButtonClicked?: boolean}>`

background-image: linear-gradient(to left, rgb(52 174 243 / 9%), rgba(52, 174, 243, 0.42));
display: flex;
// justify-content: space-between;
height: 35px;
align-items: center;
margin: 0 7px 20px 7px;
padding: 0 15px;
border-radius: 5px;
p{ 
  margin-bottom: 0;
  font-size: 12px;
  &:last-child{
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 30%;
    margin-left: 10px;
    color: #34AEF3;
    cursor: ${props => props.anyButtonClicked ? 'not-allowed' : 'pointer'};
    text-decoration: underline;
  }
}
`;

const StyledPopover = styled(Popover)`
  .ant-popover-inner-content {
      padding: 0px !important;
  }
`;

const PopoverContentWrapper = styled.div`
  margin: 6px 4px;
`;

const PopoverTitle = styled.p`
  color: var(--Black, #121212);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 15px !important;
`;

const AddDomainSection = styled.div`
  display: flex;  
  width: 460px;
  min-height: 50px;
  flex-shrink: 0;
  border-radius: 12px 12px 0px 0px;
  border: 1px solid var(--Gray-light, #E8E8E8);
  background: var(--Table-row-stripe, #F9F9FB);
  padding: 12px 16px;
`;

const ProvideUrlsSection = styled.div`
  display: flex;
  width: 460px;
  min-height: 58px;
  flex-shrink: 0;
  border-radius: 0px 0px 12px 12px;
  border: 1px solid var(--Gray-light, #E8E8E8);
  background: var(--Table-row-stripe, #F9F9FB);
  margin-bottom: 15px;
  padding: 12px 16px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

const AddDomainTitle = styled.div`
  color: var(--Black, #121212);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 2px;
`;

const AddDomainDesc = styled.div`
  color: var(--Gray-dark, #4E5156);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
`;

const AddDomainInput = styled(Input)`
  width: 400px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid var(--Gray-light, #E8E8E8);
  background: var(--White, #FFF);
`;

const DomainDetails = styled.div`
  .ant-form-item {
    margin-bottom: 0px !important;
  }  

`;

const ProvideUrlsDetails = styled.div`
  
`;

const Dismiss = styled.button`
  display: inline-flex;
  padding: 5px 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: var(--Body-background, #F2F2F5);
  border: none;
  cursor: pointer;
`;

const Update = styled(Button)`
  display: inline-flex;
  padding: 5px 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: var(--Blue, #2D6CCA);
  color: white;
  min-width: 120px;
  &:hover {
    background-color: #2D6CCA !important;
    color: white !important;
  }
  &:focus {
    background-color: #2D6CCA !important;
    color: white !important;
  }
`;

const ErrorMessageForURL = styled.span`
  color: #ff4d4f;
  font-size: 14px;
  line-height: 1.5715;
`;
